export default {
    methods: {
        getStatusClass(status){
            return {
                "badge-danger": status === "danger",
                "badge-success": status === "success",
                "badge-warning": status === "warning",
                "badge-info": status === "info",
                "badge-primary": status === "primary",
                "badge-default": status === "default"
            }
        }
    }
}
